<template>
  <v-row>
    <v-col>
      <v-card>
        <v-card-title>
          <v-icon @click="$router.push({ path: `/`})">
            arrow_back
          </v-icon>
          <v-icon class="mx-3 red--text">
            account_balance_wallet
          </v-icon>
          <h3 class="title font-weight-bold">
            Історія рахунків та оплат
          </h3>
        </v-card-title>
        <SimpleTable
          :headers="headers"
          :loading="loading"
          :items-per-page="rowsCount"
          :items="displayedItems"
        />
      </v-card>
      <div class="text-center">
        <v-pagination
          v-model="page"
          :length="setPages()"
          :total-visible="10"
          color="red lighten-2"
        />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import SimpleTable from "@/components/story/SimpleTable";
import { mapActions, mapState } from "vuex";
import paymentStateTypes from "@/helpers/paymentStateTypes";

export default {
  components: {
    SimpleTable,
  },
  data: () => ({
    loading: false,
    page: 1,
  }),
  computed: {
    ...mapState("client", ["invoices"]),
    rowsCount() {
      return Math.floor((window.innerHeight - 300) / 55);
    },
    displayedItems() {
      return this.paginate(this.invoices);
    },
    paymentStateTypes() {
      return paymentStateTypes;
    },
    headers(){
      return [
        { text: "Дата рахунку", value: "date", type: "date", width: "12%" },
        { text: "Номер", value: "number", type: "text" },
        { text: "Сума", type: "text", value: "amount" },
        { text: "Оплата", type: "text", value: "payedAmount" },
        { text: "Дата оплати", value: "lastPaymentDate", type: "date" },
        { text: "Статус", component: "Label", value: "paymentStatus", dict: this.paymentStateTypes },
      ];
    },
  },
  watch: {
    invoices() {
      this.setPages();
    },
  },
  async created() {
    await this.getInvoices();
    this.loading = false;
  },
  methods: {
    ...mapActions("client", ["getInvoices"]),
    paginate(items) {
      const page = this.page;
      const perPage = this.rowsCount;
      const from = page * perPage - perPage;
      const to = page * perPage;
      return items.slice(from, to);
    },
    setPages() {
      if (this.rowsCount === null || this.invoices === null) {
        return 0;
      }

      return Math.ceil(this.invoices.length / this.rowsCount);
    },
  },
};
</script>